import axios from "axios";
import authHeader from '../Authentification/authHeader';

const url = process.env.REACT_APP_API_URL

/** Statistiques + liste des travaux effectués sur une période ("all" = tous les merchandisers). */
export async function getTravailVisites(datedebut, datefin, user_code = 'all') {
    try {
        return await axios.get(
            `${url}rapports/travailVisite/${datedebut}/${datefin}/${user_code}`,
            { headers: authHeader() }
        );
    } catch (error) {
        console.error(error);
        return error.response;
    }
}

/** Détail d'un travail effectué : en-tête + réponses Oui / Non. */
export async function getTravailVisiteDetails(code) {
    try {
        return await axios.get(
            `${url}rapports/travailVisite/details/${encodeURIComponent(code)}`,
            { headers: authHeader() }
        );
    } catch (error) {
        console.error(error);
        return error.response;
    }
}

/** Merchandisers ayant au moins un travail saisi (pour le filtre). */
export async function getTravailVisiteUsers() {
    try {
        return await axios.get(`${url}rapports/travailVisite/users`, { headers: authHeader() });
    } catch (error) {
        console.error(error);
        return error.response;
    }
}